import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        height: "100%",
        marginTop: 20,
        overflow: "hidden",
    },
    areaContainer: {
        height: "100%",
        display: "flex",
    },
    listContainer: {
        height: "100%",
    },
}));
